import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Funnel } from "@phosphor-icons/react";

const triggerStyle = {
  background: "#11151D",
  border: "1px solid rgba(255,255,255,0.08)",
  color: "#d4d4d8",
};

export default function FilterRow({
  statusFilter, sectorFilter, sectors,
  onStatusChange, onSectorChange, resultCount,
}) {
  return (
    <div className="flex flex-wrap items-center gap-2.5 py-4" data-testid="filter-row">
      <Select value={statusFilter} onValueChange={onStatusChange}>
        <SelectTrigger
          className="w-auto min-w-[130px] h-9 rounded-lg shadow-none border-0 font-mono text-[12px] gap-2 px-3.5 focus:ring-1 focus:ring-white/20"
          style={triggerStyle}
          data-testid="status-filter"
        >
          <SelectValue placeholder="All Status" />
        </SelectTrigger>
        <SelectContent className="rounded-lg shadow-xl border font-mono" style={{ background: "#11151D", borderColor: "rgba(255,255,255,0.08)", color: "#d4d4d8" }}>
          <SelectItem value="all" className="font-mono text-[12px]">All Status</SelectItem>
          <SelectItem value="compliant" className="font-mono text-[12px]">Compliant</SelectItem>
          <SelectItem value="borderline" className="font-mono text-[12px]">Borderline</SelectItem>
          <SelectItem value="non_compliant" className="font-mono text-[12px]">Non-Compliant</SelectItem>
        </SelectContent>
      </Select>

      <Select value={sectorFilter} onValueChange={onSectorChange}>
        <SelectTrigger
          className="w-auto min-w-[140px] h-9 rounded-lg shadow-none border-0 font-mono text-[12px] gap-2 px-3.5 focus:ring-1 focus:ring-white/20"
          style={triggerStyle}
          data-testid="sector-filter"
        >
          <SelectValue placeholder="All Sectors" />
        </SelectTrigger>
        <SelectContent className="rounded-lg shadow-xl border max-h-[300px] font-mono" style={{ background: "#11151D", borderColor: "rgba(255,255,255,0.08)", color: "#d4d4d8" }}>
          <SelectItem value="all" className="font-mono text-[12px]">All Sectors</SelectItem>
          {sectors.map((sec) => (
            <SelectItem key={sec} value={sec} className="font-mono text-[12px]">{sec}</SelectItem>
          ))}
        </SelectContent>
      </Select>

      {(statusFilter !== "all" || sectorFilter !== "all") && (
        <button
          onClick={() => { onStatusChange("all"); onSectorChange("all"); }}
          className="flex items-center gap-1.5 h-9 px-3.5 rounded-lg text-[12px] font-mono text-zinc-400 hover:text-white transition-colors"
          style={triggerStyle}
          data-testid="clear-filters-btn"
        >
          <Funnel size={12} weight="bold" />
          Clear Filters
        </button>
      )}

      <div className="ml-auto shrink-0">
        <span className="text-[11px] font-mono text-zinc-500 tabular-nums" data-testid="result-count">
          {resultCount !== undefined ? `${resultCount} results` : ""}
        </span>
      </div>
    </div>
  );
}
